import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet-view_left",
  "use": "icon-sheet-view_left-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-sheet-view_left\"><g><path d=\"M8 7.6v4.8a.5.5 0 01-.777.415l-3.599-2.399a.5.5 0 010-.832l3.599-2.4A.5.5 0 018 7.602z\" /><path stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\" stroke-linecap=\"round\" d=\"M7 10h9.458\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol